import { useMutation } from '@apollo/client';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

import ErrorView from '../../components/common/ErrorView';
import { SatelliteAgentListItemFragment } from './SatelliteAgentListItem';
import { FragmentType, graphql, useFragment } from '../../__generated__';

export const ResetAgentBalanceMutation = graphql(/* GraphQL */ `
  mutation ResetAgentBalanceMutation($id: ID!) {
    resetAgentBalance(id: $id) {
      success
      message
      code
    }
  }
`);

type ResetAgentBalanceProps = {
  open: boolean;
  agent: FragmentType<typeof SatelliteAgentListItemFragment>;
  onClose: (reset?: boolean) => void;
};

const ResetAgentBalance = (props: ResetAgentBalanceProps) => {
  const { open, onClose } = props;
  const agent =
    useFragment(SatelliteAgentListItemFragment, props.agent) || null;
  const [resetAgentBalance, { loading, error }] = useMutation(
    ResetAgentBalanceMutation
  );

  const resetBalanceFunc = async () => {
    const result = await resetAgentBalance({
      variables: {
        id: agent.id,
      },
    });

    if (result?.data?.resetAgentBalance?.success) {
      onClose(true);
    }
  };

  const cancel = () => {
    onClose(false);
  };

  return (
    <Dialog
      open={open}
      onClose={cancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{'Reset Balance'}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {`Are you sure you want to reset the balance of agent ${agent.name}?`}
        </DialogContentText>
        {error && <ErrorView message={error?.message} />}
      </DialogContent>
      <DialogActions>
        <Button onClick={cancel}>Cancel</Button>
        <Button onClick={resetBalanceFunc} disabled={loading}>
          Reset balance
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResetAgentBalance;
